import React from "react";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isAllowedURL } from "../../_helper/helper";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAuth } from "oidc-react";
import { Breadcrumbs } from "../../AbstractElements";

const Header = ({ title, icon, url, ...props }) => {
  const { userData } = useAuth();
  const location = useLocation();
  const params = useParams();

  return (
    <Breadcrumbs
      mainTitle={
        <Typography variant="h5">
          {!icon && <FontAwesomeIcon icon={icon} className="m-r-10" />}
          {title}
        </Typography>
      }
      title={
        isAllowedURL(url, userData) &&
          !location.pathname.includes("payroll-employees") ? (
          <Link
            to={`${process.env.PUBLIC_URL}/${url}`}
            className="font-light"
          >
            {title}
          </Link>
        ) : "Supervisor Assignment"
      }
      parent={
        location.pathname.includes("assign")
          ? "Assign New Employee"
          : location.pathname.includes("supervisor-employees")
            ? "Assigned Employee"
            : ""
      }
    />
  );
};

export default Header;
